import { Box, Button, Flex, Text } from '@ritualco/jutsu'
import * as Yup from 'yup'
import { Form, Formik, FormikProps } from 'formik'
import { FormikInput } from 'components/Formik'
import { CardPage } from 'components/PageTemplates'
import { FormattedMessage } from 'lib/content/react'

interface WorkEmailProps {
  email?: string
  onNext: (email: string) => void
}

type WorkEmailType = {
  email: string
}

export const WorkEmail = ({ email = '', onNext }: WorkEmailProps) => {
  let validationSchema = Yup.object().shape({
    // TODO: validation errors and field labels to localize
    email: Yup.string().email('Invalid email').required('Required'),
  })

  return (
    <CardPage trackingName="WorkEmail">
      <Box>
        <Information />
        <Formik
          enableReinitialize
          initialValues={{ email }}
          onSubmit={async (values, actions) => {
            onNext(values.email)
          }}
          validationSchema={validationSchema}
        >
          {(props: FormikProps<WorkEmailType>) => (
            <Form>
              <Box pt={8}>
                <FormikInput
                  name="email"
                  label={
                    <FormattedMessage id="pmportal.onboarding.workEmailInputLabel" />
                  }
                  isRequired
                />
                <Text
                  fontSize={'xs'}
                  fontWeight={'medium'}
                  color={'grayscale.secondary'}
                  mt={4}
                >
                  <FormattedMessage id="pmportal.onboarding.workEmailCaption" />
                </Text>
              </Box>
              <Flex justifyContent="flex-end" mt={10}>
                <Button type="submit" size="lg" disabled={!!props.errors.email}>
                  <FormattedMessage id="pmportal.global.actionNext" />
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </CardPage>
  )
}

const Information = () => (
  <Flex direction={'column'} alignItems={'center'} fontSize={'sm'}>
    <Text>
      <FormattedMessage id="pmportal.onboarding.stepX" values={{ x: 1 }} />
    </Text>
    <Text align={'center'} fontSize={'3xl'} fontWeight={'bold'} pt={2} pb={2}>
      <FormattedMessage id="pmportal.onboarding.workEmailTitle" />
    </Text>
    <Text textAlign={'center'} color={'grayscale.secondary'} fontSize={'sm'}>
      <FormattedMessage id="pmportal.onboarding.workEmailDescription" />
    </Text>
  </Flex>
)
